import { Icon } from '@chakra-ui/react';

const PCDividerIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<g>
				<path class="st0" d="M26.69,28.61H2.5l-0.08-0.03c-0.76-0.27-1.2-0.73-1.36-1.4C1.02,27.03,1,26.88,1,26.74c0-1.5,0-3,0-4.5
			c0-1.03,0.75-1.82,1.78-1.88c0.1-0.01,0.21-0.01,0.31-0.01H8c6.04,0,12.08,0,18.11,0c0,0,0,0,0,0c0.5,0,1.23,0.08,1.72,0.77
			c0.11,0.16,0.18,0.32,0.25,0.46c0.02,0.05,0.05,0.1,0.07,0.15l0.05,0.11v5.26l-0.02,0.08c-0.22,0.7-0.71,1.19-1.41,1.41
			L26.69,28.61z M2.68,27.57h23.84c0.32-0.12,0.52-0.32,0.64-0.64v-4.86c-0.01-0.03-0.02-0.05-0.04-0.08
			c-0.05-0.11-0.09-0.21-0.14-0.28c-0.14-0.2-0.35-0.33-0.88-0.33c0,0,0,0,0,0c-6.04,0-12.08,0-18.12,0H3.1
			c-0.08,0-0.17,0-0.25,0.01c-0.48,0.03-0.81,0.37-0.81,0.85c0,1.5,0,3,0,4.5c0,0.07,0.01,0.14,0.03,0.21
			C2.11,27.15,2.22,27.39,2.68,27.57z"/>
			</g>
			<g>
				<path class="st0" d="M17.98,9.65c-4.96,0-9.92,0-14.87,0c-0.24,0-0.53-0.01-0.8-0.09C1.54,9.34,1,8.61,1,7.8c0-1.13,0-2.27,0-3.4
			l0-1.02c0-1.2,0.78-1.98,1.98-1.98l21.82,0l1.44,0c0.93,0,1.56,0.43,1.88,1.29c0,0,0,0,0,0l0.1,0.14v5.33l-0.07,0.17
			c-0.02,0.06-0.05,0.12-0.07,0.17c-0.3,0.69-0.85,1.09-1.58,1.15c-0.14,0.01-0.28,0.01-0.4,0.01h-0.5
			C23.05,9.65,20.52,9.65,17.98,9.65z M18.09,2.43l-15.12,0c-0.62,0-0.94,0.32-0.94,0.95l0,1.02c0,1.13,0,2.27,0,3.4
			c0,0.36,0.23,0.67,0.56,0.77c0.15,0.04,0.34,0.05,0.51,0.05c7.49,0,14.98,0,22.48,0h0.5c0.11,0,0.21,0,0.31-0.01
			c0.35-0.03,0.57-0.2,0.72-0.54c0.02-0.04,0.04-0.08,0.05-0.13V3.13c0-0.01-0.01-0.02-0.01-0.04c-0.17-0.49-0.41-0.66-0.92-0.66
			l-1.44,0L18.09,2.43z"/>
			</g>
			<g>
				<path class="st0" d="M15.08,14.53c0.71,0.07,0.88,0.16,0.88,0.47c0,0.32-0.19,0.43-0.88,0.47c0,0.8,0,1.61,0,2.44
			c0.06-0.04,0.12-0.09,0.18-0.12c0.2-0.12,0.44-0.09,0.58,0.08c0.15,0.18,0.18,0.39,0.02,0.56c-0.31,0.35-0.65,0.68-0.99,0.99
			c-0.18,0.16-0.42,0.12-0.62-0.07c-0.27-0.27-0.54-0.54-0.81-0.81c-0.22-0.23-0.24-0.49-0.07-0.68c0.17-0.19,0.41-0.19,0.66-0.01
			c0.02,0.02,0.05,0.04,0.1,0.07c0-0.84,0-1.64,0-2.45c-0.37-0.04-0.88,0.1-0.87-0.48c0.01-0.55,0.5-0.43,0.87-0.46
			c0-0.81,0-1.62,0-2.45c-0.07,0.05-0.13,0.1-0.19,0.13c-0.2,0.11-0.4,0.09-0.56-0.08c-0.16-0.17-0.19-0.39-0.04-0.56
			c0.32-0.35,0.66-0.69,1.01-1.01c0.17-0.15,0.41-0.11,0.6,0.07c0.29,0.28,0.57,0.56,0.85,0.85c0.2,0.2,0.21,0.46,0.05,0.64
			c-0.17,0.2-0.41,0.21-0.66,0.03c-0.03-0.02-0.05-0.04-0.1-0.08C15.08,12.91,15.08,13.71,15.08,14.53z"/>
			</g>
			<g>
				<path class="st0" d="M3.76,15.46c-0.29,0-0.58,0.01-0.87,0C2.61,15.45,2.42,15.26,2.42,15c0-0.26,0.19-0.45,0.48-0.45
			c0.58-0.01,1.16-0.01,1.74,0c0.29,0,0.49,0.19,0.5,0.44c0.01,0.26-0.2,0.46-0.5,0.47C4.34,15.46,4.05,15.46,3.76,15.46z"/>
			</g>
			<g>
				<path class="st0" d="M7.36,15.46c-0.28,0-0.56,0-0.84,0c-0.3-0.01-0.51-0.21-0.5-0.47c0.01-0.25,0.21-0.44,0.5-0.44
			c0.58,0,1.16-0.01,1.74,0c0.29,0,0.48,0.19,0.48,0.45c0,0.26-0.19,0.45-0.47,0.46C7.96,15.46,7.66,15.46,7.36,15.46z"/>
			</g>
			<g>
				<path class="st0" d="M10.97,15.46c-0.28,0-0.56,0-0.84,0c-0.3-0.01-0.49-0.19-0.49-0.47c0.01-0.26,0.2-0.44,0.49-0.44
			c0.58,0,1.16-0.01,1.74,0c0.28,0,0.48,0.2,0.48,0.45c0,0.26-0.2,0.45-0.48,0.46C11.57,15.46,11.27,15.46,10.97,15.46z"/>
			</g>
			<g>
				<path class="st0" d="M18.18,15.46c-0.28,0-0.56,0-0.84,0c-0.28-0.01-0.48-0.2-0.48-0.45c0-0.26,0.2-0.45,0.48-0.46
			c0.59-0.01,1.17-0.01,1.76,0c0.28,0,0.47,0.2,0.47,0.46c0,0.25-0.19,0.44-0.46,0.44C18.79,15.46,18.49,15.46,18.18,15.46z"/>
			</g>
		</g>

	</Icon>
);

export default PCDividerIcon;
